module.exports = __webpack_public_path__ + "img/banner-1.941d3f59.jpg";